module.exports = __webpack_public_path__ + "img/SketchPng274b3293f7eb25a1274b7d7cb3a078a0eafb25d80c7d196d45c438a989c13e53.84e94842.png";